import { Component } from 'react';

export default class GrantsApplicationMobileBlockPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            closing: false
        }
    }

    onClose() {
        const CLOSING_TIME = 300;

        this.setState({ closing: true }, () => {
            setTimeout(() => this.props.close(), CLOSING_TIME);
        })
    }

    render() {
        const { children } = this.props;

        return (
            <div className={`grants-application__mobile-popup ${this.state.closing ? 'disappearUnderAnimation' : ''}`}>
                <div className="grants-application-mobile-popup__head" onClick={this.onClose.bind(this)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.556" viewBox="0 0 16 15.556">
                        <path id="Path_170" data-name="Path 170" d="M16.172,11,10.808,5.636l1.414-1.414L20,12l-7.778,7.778-1.414-1.414L16.172,13H4V11Z" transform="translate(-4 -4.222)" fill="#1577ea"/>
                    </svg>
                    Return to main application
                </div>
                <div className="grants-application-mobile-popup__content">
                    { children }
                </div>
            </div>
        )
    }
}